define('views/pages/account/AccountPaymentView',['hooks', 'underscore', 'jquery', 'views/pages/account/AccountView',
        'views/blocks/OgoneView',
        'views/blocks/OgoneDirectView',
        'SelectView',
        'models/EdenredDataModel',
        'app',
        'InternalLinkView',
        'views/blocks/checkout/PaymentModeSelectionModalView',
        'template!blocks/account/payment',
        'template!blocks/account/edenred',
        'models/PaymentMethodModel'
    ],
    function (hooks, _, $, AccountView, OgoneView,
              OgoneDirectView,
              SelectView,
              EdenredDataModel,
              app,
              InternalLinkView,
              PaymentModeSelectionModalView,
              paymentTemplate,
              edenredTemplate
    ) {

        //
        // Account Loyalty View
        // représente la loyalty de la page mon compte
        //

        var view,ogoneView, OgoneDirectView;

        return AccountView.extend({

            events: {
                'change select.selectstore':'updateSelectStore',
                'click .logout-edenred':'logoutEdenred',
                'click .login-edenred':'loginEdenred',
                'click .card__remove':'removeCard',
                'click .add__card':'addCard',
            },

            initialize: function () {
                view = this;
                AccountView.prototype.initialize.apply(view,arguments);
                view.listenTo(EdenredDataModel,'change sync',view.renderEdenred);
                view.listenTo(app.getCustomer(),'change:card addCard',view.render);
                view.render();
            },
            removeCard:function(e){
                var view = this,
                    button = e.currentTarget,
                    id_card = $(button).data('id_card'),
                    cardEl = view.$(button).parents('.card');
                button.disabled = true;

                cardEl.slideUp(function(){
                    cardEl.remove();
                });
                app.getCustomer().removeCard(id_card);
            },
            addCard:function(){
                var ogonePaymentMode = app.getPaymentModes().findWhere({provider:'OgoneProvider'}).clone();
                    ogonePaymentMode.setOption('storepermently','Y',true);
                    ogonePaymentMode.setOption('cvc','888',true);
                var requirement = ogonePaymentMode.getRequirement();
                var modalView = new PaymentModeSelectionModalView({
                    paymentMode:ogonePaymentMode,
                    requirement:requirement
                });
                app.displayModal(modalView);
            },
            render: function () {
                var view = this;
                var ogonePaymentMode = app.getPaymentModes().findWhere({provider:'OgoneProvider'}),
                 ogoneDirectPaymentMode = app.getPaymentModes().findWhere({provider:'OgoneDirectProvider'}),
                    cards = _([]);
                if(ogonePaymentMode){
                    cards = ogonePaymentMode.getCards();
                }
                if(ogoneDirectPaymentMode){
                    cards = ogoneDirectPaymentMode.getCards();
                }

                var options = {
                    add_card_label:app.t('Ajouter une nouvelle carte','Account'),
                    cards:cards,
                    EdenredData:EdenredDataModel,
                    edenredTemplate:edenredTemplate
                };
                view.$el.html(paymentTemplate(options));
                InternalLinkView.initializeLinksOfView(view);
            },
            renderEdenred:function(){
                var view = this, content = $(edenredTemplate(EdenredDataModel))
                view.$('.edenred').remove();
                view.$('.account-payment').append(content);
                view.delegateEvents();
            },
            logoutEdenred:function(e){
                var btn = $(e.currentTarget);
                btn.toggleClass('loading').attr('disabled',true);
                EdenredDataModel.logout().fail(function(){
                    app.alert();
                }).always(function(){
                    EdenredDataModel.remoteFetch();
                })
            },
            loginEdenred:function(e){
                app.displayModal(new PaymentModeSelectionModalView({
                    group:1
                }));
            },
            
        });
    });
